import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { from, Observable, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private auth: Auth
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Only do this for the API calls
        if (!request.url.includes(environment.apiBaseUrl)) {
            return next.handle(request);
        }

        const publicRoutes = ['/geo']; // Should match with the public routes defined in the API
        const isPublicRoute = publicRoutes.some(route => request.url.includes(route));
        if (isPublicRoute) {
            return next.handle(request);
        }

        const promise = this.auth.currentUser?.getIdToken();
        const token$ = !!promise ? from(promise) : of();
        return token$.pipe(
            switchMap(token => {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
                return next.handle(request);
            })
        );
    }
}
